























import { Component, Vue, Prop } from 'vue-property-decorator';
import { IInterview } from '@/types/Interview';
import InterviewPostCard from '@/components/InterviewPostCard.vue';
import GMJLinkButtons from '@/containers/GMJLinkButtons.vue';

@Component({
  components: {
    InterviewPostCard,
    GMJLinkButtons
  }
})
export default class Interview extends Vue {
  @Prop() private post!: IInterview[];

  public get posts() {
    return this.$store.getters['interview/getPosts'];
  }
}
